export default {
  getBoard: {
    url: '/replenishment/board',
    method: 'post',
    desc: '看板数据获取'
  },
  simulate: {
    url: '/replenishment/simulate',
    method: 'post',
    desc: '模拟补货'
  },
  sales: {
    url: '/replenishment/sales',
    method: 'post',
    desc: '销量趋势'
  },
}
